import React from 'react';
import { ProgressBar } from 'react-native-paper';

import ProgressBarNyanCat from '../components/ProgressBarNyanCat';
import ProgressStepper from '../components/ProgressStepper';

export type ProgressIndicatorProps = {
  progress: number;
  total: number;
  variant: 'default' | 'rainbowCat' | 'stepper';
  styleConfig: Record<string, any>;
};

const ProgressIndicatorSwitcher: React.FC<ProgressIndicatorProps> = ({
  progress,
  total,
  variant,
  styleConfig,
}) => {
  if (variant === 'rainbowCat') {
    return (
      <ProgressBarNyanCat
        progress={progress}
        total={total}
        barSize={{
          width: styleConfig.progressBarNyanCat?.bar?.size?.width ?? 240,
          height: styleConfig.progressBarNyanCat?.bar?.size?.height ?? 18,
        }}
        catSize={{
          width: styleConfig.progressBarNyanCat?.nyanCat?.size?.width ?? 47,
          height: styleConfig.progressBarNyanCat?.nyanCat?.size?.height ?? 28,
        }}
        backgroundColor={
          styleConfig.progressBarNyanCat?.backgroundColor ?? '#FFFFFF'
        }
      />
    );
  }

  if (variant === 'stepper') {
    return (
      <ProgressStepper
        styleConfig={styleConfig?.progressStepper}
        progress={progress}
        total={total}
      />
    );
  }

  return (
    <ProgressBar
      progress={progress / total}
      color={styleConfig.progressBar?.bar?.backgroundColor || '#0175FF'}
      style={{
        width: styleConfig.progressBar?.size?.width || 160,
        height: styleConfig.progressBar?.size?.height || 2,
        borderRadius: 2,
        backgroundColor: styleConfig.progressBar?.backgroundColor || '#E9EFF2',
      }}
    />
  );
};

export default ProgressIndicatorSwitcher;
